<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="500"
    min-width="850px"
    max-width="1400px"
    max-height="800px"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="success" depressed v-bind="attrs" v-on="on">
        <v-icon left>mdi-plus</v-icon>Hinzufügen
      </v-btn>
    </template>

    <v-card outlined>
      <v-card-title class="font-weight-medium"
        ><span class="text-subtitle-1 font-weight-medium">{{ title }}</span>
        <v-spacer></v-spacer>
        <v-btn icon small @click="close()"
          ><v-icon small>mdi-close</v-icon></v-btn
        >
      </v-card-title>
      <v-card-subtitle>
        <v-text-field
          v-model="search"
          outlined
          dense
          label="Suchen"
          hide-details="auto"
          prepend-inner-icon="mdi-magnify"
          class="mt-2"
          clearable
        ></v-text-field>
        <v-select
          v-model="statusFilter"
          :items="statusValues"
          label="Nach Status filtern"
          outlined
          multiple
          dense
          required
          item-text="text"
          item-value="value"
          prepend-inner-icon="mdi-filter"
          hide-details="auto"
          class="mt-3"
        >
          <template v-slot:selection="data">
            <personnel-record-status-chip
              :status="data.item.value"
              small
              class="mr-1"
              @click="toggle"
            >
            </personnel-record-status-chip>
          </template>
        </v-select>
      </v-card-subtitle>
      <v-divider></v-divider>
      <v-data-table
        v-model="selectionLocal"
        :headers="headers"
        :items="listItems"
        :search="search"
        item-key="user.uid"
        sort-by="lastName"
        group-by="groupByDivision"
        fixed-header
        height="300"
        dense
        show-select
        checkbox-color="primary"
        mobile-breakpoint="0"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:[`group.header`]="{ items, isOpen, toggle }">
          <th :colspan="headers.length++">
            <v-icon @click="toggle" class="mr-2"
              >{{ isOpen ? "mdi-chevron-up" : "mdi-chevron-down" }}
            </v-icon>
            <span>
              {{ stripPrefix(items[0].groupByDivision) }}
            </span>
          </th>
        </template>
        <template v-slot:[`item.personnelNumber`]="{ item }">
          <pre>{{ item.personnelNumber }}</pre>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <personnel-record-status-chip :status="item.status" small>
          </personnel-record-status-chip>
        </template>
        <template v-slot:[`item.dueDate`]="{ item }">
          <pre v-if="item.dueDate">{{ timestampConverter(item.dueDate) }}</pre>
        </template>
        <template v-slot:[`item.labels`]="{ item }">
          <v-chip
            v-for="(label, index) in item.labels"
            :key="index"
            x-small
            outlined
            class="mr-1 my-1"
            :color="label.color"
          >
            {{ label }}</v-chip
          >
        </template>
        <template v-slot:[`item.info`]="{ item }">
          <v-tooltip bottom v-if="item.pendingUpdate">
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                dense
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                class="mr-1"
              >
                mdi-information
              </v-icon>
            </template>
            <span
              >Aktualisierung ausstehend
              <br />
              <strong>Neuer Wert:</strong>
              {{ timestampConverter(item.pendingUpdate.newDueDate) }}
              <v-chip
                v-for="(label, index) in item.pendingUpdate.newLabels"
                :key="index"
                x-small
                outlined
                class="mr-1 my-1"
              >
                {{ label }}</v-chip
              >
            </span>
          </v-tooltip>
          <v-tooltip bottom v-if="item.scheduledRenewal">
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="primary" dense dark v-bind="attrs" v-on="on">
                mdi-calendar
              </v-icon>
            </template>
            <span>Erneuerung geplant</span>
            <br />
            <strong>Geplanter Termin:</strong>
            {{ timestampConverterWithTime(item.scheduledRenewal.timestamp)
            }}<br />
            <strong>Ort:</strong>
            {{ item.scheduledRenewal.location }}
            <br />
            {{ item.scheduledRenewal.note }}
          </v-tooltip>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      <v-card-text>
        <slot name="additionalForm"></slot>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="px-3">
        <v-btn depressed
          ><v-icon left @click="$emit('resetForm')">mdi-reload</v-icon
          >Zurücksetzen</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="success"
          @click="submitForm()"
          :disabled="addBtnDisabled"
          ><v-icon left>mdi-plus</v-icon>Hinzufügen</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<style></style>

<script>
import PersonnelRecordStatusChip from "@/components/member-management/personnel-records/PersonnelRecordStatusChip.vue";
export default {
  name: "new-entry-table-selector-menu",
  props: {
    selection: {},
    items: {},
    title: {
      type: String,
      default: "Personen auswählen",
      required: false,
    },
    additionalHeaders: {
      type: Array,
      default: () => [],
    },
    addBtnDisabled: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "selection",
    event: "selectionChange",
  },
  components: { PersonnelRecordStatusChip },
  computed: {
    selectionLocal: {
      get: function () {
        return this.selection;
      },
      set: function (value) {
        this.$emit("selectionChange", value);
      },
    },
    listItems() {
      return this.items
        .map((record) => {
          return {
            ...record,
            groupByDivision:
              record.division.sortKey.toString().padStart(4, "0") +
              "_" +
              record.division.title,
          };
        })
        .filter((record) => {
          return this.statusFilter.includes(record.status);
        });
    },
    defaultHeaders() {
      return this.headers.filter((header) => header.default);
    },
    defaultState() {
      return (
        this.selectionLocalBuffer.length === this.defaultHeaders.length &&
        this.selectionLocalBuffer.every((item) => item.default)
      );
    },
    headers() {
      let headers = [
        {
          text: "Personalnr.",
          value: "personnelNumber",
          align: "start",
        },
        {
          text: "Vorname",
          value: "firstName",
          align: "start",
        },
        {
          text: "Nachname",
          value: "lastName",
          align: "start",
          divider: true,
        },
        {
          text: "Status",
          value: "status",
          align: "start",
          divider: true,
        },
      ];
      return headers.concat(this.additionalHeaders);
    },
  },
  data() {
    return {
      menu: false,
      search: "",
      statusFilter: ["active", "onLeave", "transfer"],
      statusValues: [
        { text: "Aktiv", value: "active", color: "#4CAF50" },
        { text: "Beurlaubt", value: "onLeave", color: "#FF9800" },
        { text: "Ausgetreten", value: "resigned", color: "#795548" },
        { text: "Im Übertritt", value: "transfer", color: "#CDDC39" },
        { text: "Entlassen", value: "dismissed", color: "#F44336" },
        { text: "Verstorben", value: "deceased", color: "#9E9E9E" },
      ],
    };
  },
  created() {
    this.selectionLocalBuffer = this.selectionLocal;
  },
  methods: {
    close() {
      this.menu = false;
    },
    submitForm() {
      this.$emit("submitForm", this.selectionLocal);
      this.close();
    },
    stripPrefix(item) {
      return item.substring(item.indexOf("_") + 1);
    },
    timestampConverter(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
    timestampConverterWithTime(timestamp) {
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      return timestamp.toDate().toLocaleDateString("de-DE", options);
    },
  },
};
</script>
